import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["onClick"]
const _hoisted_2 = { class: "item-tit" }
const _hoisted_3 = {
  key: 1,
  class: "sub-tit"
}
const _hoisted_4 = ["onClick"]
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "item-tit" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_row = _resolveComponent("a-row")!
  const _directive_widthoverflowtitle = _resolveDirective("widthoverflowtitle")!

  return (_openBlock(), _createBlock(_component_a_row, {
    gutter: _ctx.gutter,
    wrap: true
  }, {
    default: _withCtx(() => [
      (!_ctx.isSubject)
        ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.courses, (course) => {
            return (_openBlock(), _createBlock(_component_a_col, {
              class: "block",
              span: _ctx.span,
              key: course.courseNo
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", {
                  class: "item",
                  onClick: ($event: any) => (_ctx.jumpToCourse(course.courseNo, course.lessonNo || course.chapterNo || course.subCourseNo))
                }, [
                  (course.coverImage)
                    ? (_openBlock(), _createElementBlock("p", {
                        key: 0,
                        class: "bg-img",
                        style: _normalizeStyle({backgroundImage: `url(${course.coverImage})`})
                      }, null, 4))
                    : _createCommentVNode("", true),
                  _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_2, [
                    _createTextVNode(_toDisplayString(course.lessonName || course.courseName), 1)
                  ])), [
                    [_directive_widthoverflowtitle, course.lessonName || course.courseName]
                  ]),
                  (_ctx.withoutIntroduce)
                    ? _withDirectives((_openBlock(), _createElementBlock("p", _hoisted_3, [
                        _createTextVNode(_toDisplayString(course.introduction), 1)
                      ])), [
                        [_directive_widthoverflowtitle, course.introduction]
                      ])
                    : _createCommentVNode("", true),
                  _createElementVNode("div", {
                    class: "palyer-btn",
                    onClick: ($event: any) => (_ctx.jumpToCourse(course.courseNo, course.lessonNo || course.chapterNo || course.subCourseNo))
                  }, null, 8, _hoisted_4)
                ], 8, _hoisted_1)
              ]),
              _: 2
            }, 1032, ["span"]))
          }), 128))
        : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.courses, (item) => {
            return (_openBlock(), _createBlock(_component_a_col, {
              class: "block",
              span: 6,
              key: item.id
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", {
                  class: "item",
                  onClick: ($event: any) => (_ctx.gotoSpecialCourse(item))
                }, [
                  _createElementVNode("div", {
                    class: "bg-img",
                    style: _normalizeStyle({backgroundImage: `url(${item.image})`})
                  }, null, 4),
                  _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_6, [
                    _createTextVNode(_toDisplayString(item.groupName), 1)
                  ])), [
                    [_directive_widthoverflowtitle, item.groupName]
                  ])
                ], 8, _hoisted_5)
              ]),
              _: 2
            }, 1024))
          }), 128))
    ]),
    _: 1
  }, 8, ["gutter"]))
}